import React from 'react'

export default ({text, hasTopMargin}) => <h6 style={{marginTop: hasTopMargin ? '3rem' : 0}}>{text}</h6>